import {BaseEntity} from "../common/base-entity";
import { CirfBrokerInfo } from './cirf-broker-info';
import {CirfUdf} from "./cirf-udf";

export class CirfInsuranceDetail extends BaseEntity {
    companyName: string;
    policyNumber: string;
    insuranceBroker: CirfBrokerInfo = new CirfBrokerInfo();
    insuranceUdfs : CirfUdf[] = [];

    hasErrors: boolean;

    constructor(cirfInsuranceDetail?: CirfInsuranceDetail) {
        super(cirfInsuranceDetail);
        if(cirfInsuranceDetail) {
            if(cirfInsuranceDetail.insuranceBroker) {
                this.insuranceBroker = new CirfBrokerInfo(cirfInsuranceDetail.insuranceBroker);
            }
            this.insuranceUdfs = [];
            if(cirfInsuranceDetail.insuranceUdfs){
                cirfInsuranceDetail.insuranceUdfs.forEach((udf)=>{
                    this.insuranceUdfs.push(new CirfUdf(udf));
                });
            }
        }
        if(!this.companyName){
            this.companyName  = '';
        }
        if(!this.policyNumber){
            this.policyNumber  = '';
        }
    }

    get entityName() : string {
        return 'fireInsuranceDetail';
    }

}
